import styled from 'styled-components';

const FundamentalsStyled = styled.div`
  .table-wrap table tbody td:last-child,
 .table-wrap table thead th:last-child {
    padding-left: 48px;
  }
`;
export default FundamentalsStyled;
